import { API_BASE_URL1 } from "../Services/baseApiUrl";
import axiosInstance from "../../Hooks/axoisInstance";

const getToken = () => {
  return localStorage.getItem("token");
};

export const GetOperations = async () => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 + `GMAM/Attendance/GetOperations`,
      {
        headers: {
             Authorization: `Bearer ${getToken()}` 
            },
      }
    );

    console.log("Full API Response:", response); // Logs full response
    console.log("Response Data:", response.data); // Logs just the data

    // Check where the array is inside response.data
    const operationsData = Array.isArray(response.data.operations)
      ? response.data.operations
      : Array.isArray(response.data.data)
      ? response.data.data
      : [];

    console.log("Operations Data (Final):", operationsData); // Log the processed data

    return operationsData;
  } catch (error) {
    console.error("Error fetching operations:", error);
    return [];
  }
};

export const GetDesignations = async () => {
    try {
      const response = await axiosInstance.get(
        API_BASE_URL1 + `GMAM/Attendance/GetDesignations`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );
  
      
  
      // Extracting the designations array safely
      const designationsData = Array.isArray(response.data.designations)
        ? response.data.designations
        : Array.isArray(response.data.data)
        ? response.data.data
        : [];
  
      console.log("Designations Data (Final):", designationsData);
      return designationsData;
    } catch (error) {
      console.error("Error fetching designations:", error);
      return [];
    }
  };
  
